module.exports = __webpack_public_path__ + "static/media/shark.cde376a3.jpg";